require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-photo-video-micro-video-bundle.json") })
        }
      }, "path---services-photo-video-micro-video-bundle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-photo-video-micro-video-bundle!./.cache/json/services-photo-video-micro-video-bundle.json
// module id = 761
// module chunks = 231608221292675